import { APIMethod, fetchData } from "@client";

export async function deleteAccountQuery(password) {
  await fetchData("/user/delete", APIMethod.DELETE, { data: { password } });
}
